import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that checks if the current URL path corresponds to a fund investment company page
 * Company URLs follow the pattern: /firms/:firmSlugParam/fund-investments/:companySlugParam/:tableSlugParam
 *
 * @returns {boolean} True if the current path is a company path, false otherwise
 */
export const useIsFundInvestmentCompanyPath = (): boolean => {
  const location = useLocation();

  const isFundInvestmentCompanyPath = useMemo(
    () => location.pathname.includes('/fund-investments/'),
    [location.pathname]
  );

  return isFundInvestmentCompanyPath;
};
